import type { QueryClient } from '@tanstack/react-query';
import type { SchemaUserResolver_GetTeamsByCorporation } from 'cpool-tables/backend-resolvers';

import { queryKeys } from '~/utils/queryKeys';

export const seedSpecificCache = ({
    queryClient,
    teams,
}: {
    queryClient: QueryClient;
    teams: SchemaUserResolver_GetTeamsByCorporation;
}) => {
    // leaders get their own row with the same controls, so they are seeded too
    const teamMembers = teams.flatMap(({ teamLeader, teamMembers: members }) =>
        teamLeader ? [teamLeader, ...members] : members,
    );
    // eslint-disable-next-line no-restricted-syntax
    for (const teamMember of teamMembers) {
        const bucketsQueryKey = queryKeys.getBuckets(teamMember.id);
        const delegateIdQueryKey = queryKeys.getDelegateId(teamMember.id);
        const leadTrackQueryKey = queryKeys.getLeadTrackStatus(teamMember.id);
        queryClient.setQueryData(bucketsQueryKey, teamMember.buckets);
        queryClient.setQueryData(delegateIdQueryKey, teamMember.delegateId);
        queryClient.setQueryData(leadTrackQueryKey, teamMember.assignable);
    }
};
